import { __assign, __extends, __rest } from "tslib";
import React from 'react';
import { compose } from 'redux';
import classnames from 'classnames';
import Dropzone from 'react-dropzone';
import { withTranslation } from 'react-i18next';
import { withVerification, } from '../VerificationPopup/withVerification';
import s from './UploadDropzone.scss';
var enhance = compose(withVerification, withTranslation());
var UploadDropzone = /** @class */ (function (_super) {
    __extends(UploadDropzone, _super);
    function UploadDropzone() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { dragInProgress: false };
        _this.dragCount = 0;
        _this.onFileDrop = function (acceptedFiles, rejectedFiles) {
            var _a = _this.props, uploadFile = _a.uploadFile, isVerificationNeeded = _a.isVerificationNeeded, pushVerificationPopup = _a.pushVerificationPopup;
            var file = acceptedFiles[0];
            if (!file) {
                return;
            }
            if (isVerificationNeeded) {
                pushVerificationPopup('submit');
                return;
            }
            uploadFile(file);
        };
        _this.onDragEnterLeave = function (e) {
            e.preventDefault();
            switch (e.type) {
                case 'dragenter':
                    _this.dragCount++;
                    break;
                case 'dragleave':
                    _this.dragCount--;
                    break;
                case 'drop':
                    _this.dragCount = 0;
                    break;
                default:
                // noop
            }
            _this.setState({ dragInProgress: _this.dragCount === 1 });
        };
        return _this;
    }
    UploadDropzone.prototype.componentDidMount = function () {
        document.addEventListener('dragenter', this.onDragEnterLeave, true);
        document.addEventListener('dragleave', this.onDragEnterLeave, true);
        document.addEventListener('drop', this.onDragEnterLeave, true);
    };
    UploadDropzone.prototype.componentWillUnmount = function () {
        document.removeEventListener('dragenter', this.onDragEnterLeave);
        document.removeEventListener('dragleave', this.onDragEnterLeave);
        document.removeEventListener('drop', this.onDragEnterLeave);
    };
    UploadDropzone.prototype.render = function () {
        var _a = this.props, className = _a.className, acceptedFileTypes = _a.acceptedFileTypes, t = _a.t;
        return (React.createElement("div", { className: classnames(s['root'], this.state.dragInProgress && s['root-active']) },
            React.createElement(Dropzone, { accept: acceptedFileTypes && acceptedFileTypes.join(), onDrop: this.onFileDrop, noClick: true }, function (_a) {
                var getRootProps = _a.getRootProps, getInputProps = _a.getInputProps, isDragActive = _a.isDragActive, isDragReject = _a.isDragReject, acceptedFiles = _a.acceptedFiles, fileRejections = _a.fileRejections, draggedFiles = _a.draggedFiles, props = __rest(_a, ["getRootProps", "getInputProps", "isDragActive", "isDragReject", "acceptedFiles", "fileRejections", "draggedFiles"]);
                // We do a special check to avoid getting a "non-accepted" state when dragging a file over
                // a dropzone that hasn't been rendered yet but will be on drag (e.g. LoadableDaEditorWrapper)
                var isDragAccept = props.isDragAccept ||
                    (draggedFiles.length > 0 &&
                        acceptedFiles.length === 0 &&
                        fileRejections.length === 0);
                return (React.createElement("div", __assign({}, getRootProps(), { className: classnames(s['dropzone'], isDragActive && s['dropzone-active'], isDragAccept && s['dropzone-accept'], isDragReject && s['dropzone-reject'], className) }),
                    React.createElement("input", __assign({}, getInputProps())),
                    React.createElement("p", null,
                        isDragActive && t('mediapopup.upload.dropzone.accept'),
                        isDragReject && t('mediapopup.upload.dropzone.reject'))));
            })));
    };
    return UploadDropzone;
}(React.Component));
export default enhance(UploadDropzone);
//# sourceMappingURL=UploadDropzone.js.map